import {Component, Inject, OnInit} from '@angular/core';
import {UiService} from "./services/ui.service";
import {DOCUMENT} from "@angular/common";
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {AuthService} from "./services/auth.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private readonly router: Router,
              private readonly uiService: UiService,
              private readonly authService: AuthService,
              @Inject(DOCUMENT) private document: Document) {
    this.authService.loadTokens();
  }

  ngOnInit(): void {
    this.uiService.headerOpened.subscribe(value => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      if (value) {
        this.document.documentElement.classList.add('page-fixed');
      } else {
        this.document.documentElement.classList.remove('page-fixed');
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.uiService.headerChanged(false);
        this.uiService.menuChanged(false);
      }
    });
  }
}
